import { Box } from '@mui/material';
import React from 'react';
import Navbar from '../Header/Navbar';
import {Header,Food} from './Components/Components'
import DiscountFooterSection from '../DiscountFooterSection/DiscountFooterSection';
import Footer from '../Footer/Footer';

function Blog(){
    return(
        <>
            <Box>
                <Navbar/>
                <Box sx={{mt:10}}>
                    <Header/>
                    <Food/>

                    <Box sx={{mt:"70px"}}>
                        <DiscountFooterSection/>
                    </Box>
                    
                </Box>
                <Footer/>
            </Box>
        </>
    )
}

export default Blog